/* @flow */
import AuthActions from 'auth/AuthActions';
import ToastActions from 'actions/ToastActions';

export type ResponseInterceptorType = (response: Object) => boolean;

export function serviceUnavailableInterceptor(response: Object): boolean {
  if (response.statusCode === 503) {
    ToastActions.showErrorToast(
      'We are currently experiencing some technical issues. Try again later.'
    );
    return true;
  }
  return false;
}

export function unauthorizedInterceptor(response: Object): boolean {
  if (response.statusCode === 401) {
    AuthActions.expireSession();
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/ResponseInterceptors.js